const API_BASE = "https://srv968119.hstgr.cloud";


export const fetchUsagers = async () => {
    const res = await fetch(`${API_BASE}/usagers`);
    return res.json();
};


export const addUsager = async (data) => {
    const res = await fetch(`${API_BASE}/usagers`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });
    return res.json();
};


export const fetchVehicules = async () => {
    const res = await fetch(`${API_BASE}/vehicules`);
    return res.json();
};
export const fetchuser = async () => {
    const res = await fetch(`${API_BASE}/users`);
    return res.json();
};
export const fetchVehiculesbyserie = async (serie) => {
    const res = await fetch(`${API_BASE}/vehicules/qrcd/`+serie);
    return res.json();
};
export const fetchVehiculesbyid = async (id) => {
    const res = await fetch(`${API_BASE}/vehicules/qrcd/`+id);
    return res.json();
};

export const addVehicule = async (data) => {
    const res = await fetch(`${API_BASE}/vehicules`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });
    return res.json();
};
export const adduser = async (data) => {
    const token = localStorage.getItem("token");
    console.log("🔍 Debug - Token from localStorage:", token ? "Token présent" : "Token manquant");
    
    const res = await fetch(`${API_BASE}/users`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify(data),
    });
    
    console.log("🔍 Debug - Response status:", res.status);
    console.log("🔍 Debug - Response headers:", res.headers);
    
    if (!res.ok) {
        const errorData = await res.json();
        console.error("❌ API Error:", errorData);
        throw new Error(errorData.error || `HTTP ${res.status}: ${res.statusText}`);
    }
    
    return res.json();
};
export const deleteUser = async (id) => {
  const res = await fetch(`${API_BASE}/users/${id}`, {
      method: "DELETE",
  });
  return res.json();
};

// Générer une plaque
export const generatePlaque = async (vehiculeId) => {
    const res = await fetch(`${API_BASE}/plaques/${vehiculeId}`, {
        method: "POST",
    });
    return res.json();
};
